import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// NewUser page components
import FormField from "components/FormField";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { URL_API } from "config";
import { toast } from "react-toastify";
import MDButton from "components/MDButton";
import { Box, FormControl, FormControlLabel, FormLabel, LinearProgress, Radio, RadioGroup } from "@mui/material";
import { useAuthContext } from "context/AuthContext";
import { AgeCalculation } from "utils/functions";

const payload = {
  full_name: "",
  social_name: "",
  birth_date: "",
  hiring_type: 1,
  email: "",
  responsible_email: "",
  cpf: "",
}

export default function CooperatedDataFirst() {
  const [cooperated, setCooperated] = useState(payload);
  const [loading, setLoading] = useState(false);

  const { uuid } = useParams();
  const { user } = useAuthContext();

  let tag = localStorage.getItem("Tag");

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        if (uuid) {
          setLoading(true)

          const response = await axios.get(`${URL_API}/cooperated/${uuid}`, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          setCooperated(response.data);

          setLoading(false)
        }
      } catch (e) {
        console.log({ error: e });

        return toast.error(e);
      }
    })()
    // eslint-disable-next-line
  }, [uuid])

  const handleNext = async () => {
    try {
      if (user.profile !== 99) {
        if (!cooperated.full_name || !cooperated.birth_date || !cooperated.email || !cooperated.cpf) return toast.warn("Preecha os dados obrigatórios");

        if (cooperated?.birth_date && cooperated?.birth_date.length === 10 && AgeCalculation(cooperated.birth_date, cooperated.hiring_type) && !cooperated.responsible_email) return toast.warn("Menor de idade. E-mail do Responsável Legal é obrigatório");

        const data = {
          ...cooperated,
          hiring_type: Number(cooperated.hiring_type),
          step: 1
        };

        if (uuid) {
          const response = await axios.put(`${URL_API}/cooperated/${uuid}`, data, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          if (response.status === 200) navigate(`/admin/colaboradores/atualizar/${uuid}?step=2`);
        } else {
          const response = await axios.post(`${URL_API}/cooperated`, data, {
            headers: {
              Authorization: `Bearer ${tag}`,
            },
          });

          if (response.status === 200) navigate(`/admin/colaboradores/atualizar/${response.data.uuid}?step=2`);
        }
      } else {
        navigate(`/admin/colaboradores/atualizar/${uuid}?step=1`);
      }
    } catch (e) {
      toast.error(e)
    }
  }

  const setInput = (event) => {
    const { name, value } = event.target;

    const newCooperated = {
      ...cooperated,
      [name]: value,
    };

    setCooperated(newCooperated);
  };

  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">Colaborador</MDTypography>
        <MDTypography variant="button" color="text">
          Informações obrigatórias *
        </MDTypography>
      </MDBox>

      {
        loading ?
          <Box sx={{ width: '100%' }}>
            <LinearProgress sx={{ overflow: 'hidden' }} />
          </Box> :
          <MDBox mt={1.625}>
            <FormControl sx={{ marginY: 2 }}>
              <FormLabel sx={{ fontSize: 13 }}>Tipo de Contratação</FormLabel>
              <RadioGroup row name="hiring_type" value={cooperated.hiring_type} onChange={setInput}>
                <FormControlLabel value={1} control={<Radio />} label="Empregado Fixo" />
                <FormControlLabel value={3} control={<Radio />} label="Estagiário" />
                <FormControlLabel value={2} control={<Radio />} label="Jovem Aprendiz" />
              </RadioGroup>
            </FormControl>

            <FormField
              type="text"
              label="Nome completo"
              name="full_name"
              value={cooperated?.full_name}
              placeholder="Nome completo"
              onChange={setInput}
              required
            />

            <FormField
              type="text"
              label="Nome social"
              name="social_name"
              value={cooperated?.social_name}
              placeholder="Nome social"
              onChange={setInput}
            />

            <FormField
              type="email"
              label="E-mail"
              name="email"
              value={cooperated?.email}
              placeholder="E-mail"
              onChange={setInput}
              required
            />

            <FormField
              type="text"
              label="CPF"
              name="cpf"
              value={cooperated?.cpf}
              placeholder="CPF"
              mask="CPF"
              onChange={setInput}
              required
            />

            <FormField
              type="text"
              label="Data de Nascimento"
              name="birth_date"
              value={cooperated?.birth_date}
              mask="date"
              placeholder="Data de Nascimento"
              onChange={setInput}
              required
            />

            {(cooperated?.birth_date && cooperated?.birth_date.length === 10 && AgeCalculation(cooperated?.birth_date, cooperated.hiring_type)) && <FormField
              type="email"
              label="E-mail do Responsável Legal"
              name="responsible_email"
              value={cooperated.responsible_email}
              placeholder="E-mail do Responsável Legal"
              onChange={setInput}
            />}
          </MDBox>
      }

      <MDBox
        mt={2}
        width="100%"
        display="flex"
        justifyContent={user?.profile !== 99 ? "space-between" : "flex-end"}
      >
        {user?.profile !== 99 && <MDButton
          variant="gradient"
          color="light"
          onClick={() => navigate(`/admin/colaboradores/atualizar/${uuid}`)}
        >
          voltar
        </MDButton>}

        <MDButton
          type="submit"
          variant="gradient"
          color="dark"
          onClick={handleNext}
        >
          próximo
        </MDButton>
      </MDBox>
    </MDBox>
  );
}

// typechecking props for CooperatedDataFirst
CooperatedDataFirst.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};
